import Config from "./Config";

export default class Global {
    /**
     * 获取API的头部路径
     * @param action 
     */
    public static GetAPIUrl(action: string) {
        return `${Config.API_HOST}${action}`;
    }
}